<app-header></app-header>
<div class="main-content">
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>